enum CookieName {
  ADMIN_NAV = 'soultrics-main-sidebar-state',
  USER_TOKEN = 'soultrics-token',
}

export default CookieName;
